<gv-redemption
  [showRedemption]="showGvRedemption"
  [benefitId]="selectedBenefitId"
  [isBenefitOffer]="isBenefitOffer"
  [selectedOfferId]="offerId"
  (redemptionClosed)="handleGVRedemptionClose($event)"></gv-redemption>
